import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold uppercase tracking-wide transition',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-eol-pink/15 text-eol-pink',
        secondary: 'border-transparent bg-white/5 text-eol-white',
        outline: 'border-white/15 text-eol-white',
        success: 'border-transparent bg-eol-green/20 text-eol-green',
        danger: 'border-transparent bg-eol-red/20 text-eol-red',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}
